module.exports = __webpack_public_path__ + "img/icons8-sand-watch-100.3e8ab9e3.png";